<template>
  <main class="main">
    <div class="container flex flex-wrap content-start">
      <InfoBox
        :title="$t('profile.info-box.title')"
        :description="$t('profile.info-box.description')"
        img-name="product-review"
        info-box-name="profileInfoBox"
        route-name="profile"
        show-close-icon
      />
      <div
        v-if="isSuperAdmin"
        class="w-full bg-yellow-50 dark:bg-gray-800 border border-yellow-200 dark:border-gray-700 rounded-lg p-4 mb-8"
      >
        <div class="text-yellow-800 dark:text-yellow-200">
          <p><strong>You are logged in as super admin.</strong></p>
          <p>
            Please ask the user to provide you with this credential via
            <a href="https://bin.chatlyn.com" class="underline" target="_blank"
              >bin.chatlyn.com</a
            >
            when necessary
          </p>
        </div>
      </div>
      <template v-else>
        <ProfileInfo class="mb-8" />
        <ProfilePassword class="mb-8" />
        <ProfileApiKeys v-if="apiKey" :api-key="apiKey" />
      </template>
    </div>
  </main>
</template>

<script lang="ts" setup>
import ProfilePassword from "@/components/app/profile/ProfilePassword.vue";
import ProfileInfo from "@/components/app/profile/ProfileInfo.vue";
import InfoBox from "@/components/app/global/InfoBox.vue";
import ProfileApiKeys from "@/components/app/profile/ProfileApiKeys.vue";
import { useOrganizationStore } from "@/stores/organizations";
import { useUserStore } from "@/stores/user";
import { computed, onMounted, watch } from "vue";

const organizationStore = useOrganizationStore();
const userStore = useUserStore();

const apiKey = computed(() => organizationStore.getters.apiKey());

const organizations = computed(() => organizationStore.getters.organizations());

const me = computed(() => userStore.getters.user());
const isSuperAdmin = computed(() => {
  return typeof me.value?.isSuperAdmin === 'boolean'
    ? me.value.isSuperAdmin
    : localStorage.getItem('isSuperAdmin') === 'true';
});

const fetchOrganizationsApiKeys = async (id: string) => {
  return await organizationStore.actions.fetchOrganizationsApiKeys(id);
};

const manageApiKeys = async (organization: any) => {
  const apiKeys = await fetchOrganizationsApiKeys(organization.organizationId);
  if (
    !apiKeys ||
    apiKeys.length === 0 ||
    !apiKeys.find((key: any) => key.active)
  ) {
    await organizationStore.actions.createOrganizationApiKey(
      organization.organizationId
    );
  }
};

watch(organizations, (newOrganizations: any[]) => {
  if (newOrganizations.length > 0) {
    manageApiKeys(newOrganizations[0]);
  }
});

onMounted(() => {
  organizationStore.actions.fetchOrganizations();
});
</script>
